import { isPlatformBrowser } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Inject, Injectable, Injector, PLATFORM_ID } from '@angular/core';
import { ErrorService } from '../services/error.service';
import { LoggerService } from '../services/logger.service';


@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
    constructor(
        private injector: Injector,
        @Inject(PLATFORM_ID) private platformId: any
    ) {
    }

    handleError(error: Error | HttpErrorResponse) {
        const errorService = this.injector.get(ErrorService);
        const logger = this.injector.get(LoggerService);
        let message;
        let stackTrace;
        if (isPlatformBrowser(this.platformId)) {
            // Client Error
            message = errorService.getClientMessage(error);
            stackTrace = errorService.getClientStack(error);
        } else {
            // Server Error
            message = errorService.getServerMessage(error);
        }
        // Always log errors
        logger.error(message, stackTrace);

        // TODO(logging): re-attach a browser-side error logger here.
        // A CloudWatch front logger (cloudwatch-front-logger -> CloudWatch Logs)
        // used to be installed in this class's constructor and shipped browser
        // errors to CloudWatch. It was removed because it signs every
        // PutLogEvents request with SigV4, whose getPayloadHash relies on Node's
        // Buffer (undefined in the browser), so every browser error log threw
        // "Buffer is not defined". When reimplementing, pick a logger whose
        // request-signing path is browser-safe (no Node Buffer dependency) or
        // forward logs through a backend endpoint instead of signing in the
        // browser. See git history: commit "disable broken cloudwatch-front-logger".
    }
}
